import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UpdateStore from '@/store/modules/update';
import { MachineSoftwareUpdateState } from '@/models/MachineSoftwareUpdateState';
import { AvailableUpdateStatus } from '@/models/AvailableUpdateStatus';
import { MachineSWUpdateData } from '@/models/MachineSWUpdateData';
import { UserProceedWithUpdateResponse } from '@/models/UserProceedWithUpdateResponse';
import { UISWUpdateData } from '@/models/UISWUpdateData';
import GlobalStore from '@/store/modules/global';
import { PubSub } from '@/PubSubClass';

@Component
export default class MachineUpdateMixIn extends Vue {
  updateStore = getModule(UpdateStore, this.$store);
  globalStore = getModule(GlobalStore, this.$store);

  get selectedMachineUpdate() {
    return this.updateStore.currentMachineUpdate;
  }

  get lastUIUpdate() {
    return this.updateStore.lastUIUpdate;
  }
  set lastUIUpdate(value: UISWUpdateData | null) {
    this.updateStore.setlastUIUpdate(value);
  }

  get selectedOptionalMachineUpdate() {
    if (this.selectedMachineUpdate?.available_update_status == AvailableUpdateStatus.OPTIONAL) return this.updateStore.currentMachineUpdate;
    else return null;
  }
  get mandatoryUpdateAvailable() {
    if (this.selectedMachineUpdate != null && this.selectedMachineUpdate?.available_update_status == AvailableUpdateStatus.MANDATORY) {
      const state = this.selectedMachineUpdate?.software_update_state;
      if (state == MachineSoftwareUpdateState.UNKNOWN || state == MachineSoftwareUpdateState.UPDATE_COMPLETED_SUCCESS) {
        return false;
      }
      return true;
    }
    return false;
  }
  public machineUpdateAvailable(machineId: string): MachineSWUpdateData | null {
    const index = this.updateStore.machineUpdates.findIndex((o) => o.machine_id.localeCompare(machineId, undefined, { sensitivity: 'base' }) == 0);
    if (index >= 0) {
      const status = this.updateStore.machineUpdates[index];
      if (status.software_update_state >= MachineSoftwareUpdateState.WAITING_FOR_USER_CONFIRMATION) return status;
      return null;
    }
    return null;
  }

  public async publishUIPayload(uiPayload: UISWUpdateData) {
    let topic = this.globalStore.UiUpdateTopic;
    topic = topic.replace('+', uiPayload.machine_id);
    const json = JSON.parse(uiPayload.fromModelToJson());
    await PubSub.publish(topic, json);
  }

  public createUIUpdatePayload(state: UserProceedWithUpdateResponse, update: MachineSWUpdateData) {
    const uiPayload = new UISWUpdateData();
    uiPayload.account_id = this.globalStore.accountId;
    uiPayload.machine_id = update.machine_id as string;
    uiPayload.machine_name = update.machine_name as string;
    uiPayload.software_update_state = update.software_update_state as MachineSoftwareUpdateState;
    uiPayload.user_proceed_with_update_response = state;
    uiPayload.ui_version = this.globalStore.packageVersion as string;

    return uiPayload;
  }
}
